import { ContextValueType, createContext } from '@berlin-front/common/composables/context';
import { shallowReactive, ref } from '@vue/composition-api';
import { simpleSetValue } from '@berlin-front/common/utils';
import atoneLogo from '@berlin-front/common/assets/atone-logo.svg';
import npLogo from '@berlin-front/common/assets/np-logo.svg';

/**
 * テーマ設定の型
 */
export type ThemeParameter = {
  primaryColor: string;
  primaryDisabledColor: string;
  primaryBackgroundColor: string;
  primaryPressedColor: string;
  outlinePressedColor: string;
  logo: string;
};

/**
 * atoneのテーマカラー
 */
export const defaultTheme = (): ThemeParameter => ({
  primaryColor: '#0092cc',
  primaryDisabledColor: '#99d6f1',
  primaryBackgroundColor: '#F5F7FA',
  primaryPressedColor: '#016E99',
  outlinePressedColor: '#CCCCCC',
  logo: atoneLogo,
});

/**
 * NP後払いのテーマカラー
 */
export const npAtobaraiTheme = (): ThemeParameter => ({
  primaryColor: '#ea5d93',
  primaryDisabledColor: '#f8c5da',
  primaryBackgroundColor: '#f5f7fa',
  primaryPressedColor: '#a84168',
  outlinePressedColor: '#a84168',
  logo: npLogo,
});

export const ThemeContext = createContext(() => {
  const themeParameter = ref<ThemeParameter>(defaultTheme());
  const setThemeParameter = simpleSetValue(themeParameter);

  return shallowReactive({
    themeParameter,
    setThemeParameter,
  });
});

export type ThemeContextType = ContextValueType<typeof ThemeContext>;
